// Phase 10e — operator dunning admin schemas (read + skip + waive + clear).
import { z } from 'zod';
import { DunningOutcomeSchema } from './enums.schema.js';
export const DunningEventResponseSchema = z.object({
    id: z.string().uuid(),
    invoiceId: z.string().uuid(),
    stepNumber: z.number().int().min(1).max(5),
    templateKey: z.string(),
    outcome: DunningOutcomeSchema,
    dispatchedAt: z.string().datetime(),
    sentByJobId: z.string().nullable(),
});
export const DunningEventListResponseSchema = z.object({
    items: z.array(DunningEventResponseSchema),
});
export const SkipNextDunningRequestSchema = z.object({
    reason: z
        .string()
        .min(10, 'Reason must be at least 10 characters — document why')
        .max(500),
});
export const WaiveInterestRequestSchema = z.object({
    period: z.string().regex(/^\d{4}-\d{2}$/, 'period must be YYYY-MM'),
    reason: z
        .string()
        .min(10, 'Reason must be at least 10 characters — document why')
        .max(500),
});
export const WaiveInterestResponseSchema = z.object({
    invoiceId: z.string().uuid(),
    period: z.string().regex(/^\d{4}-\d{2}$/),
    waivedCents: z.number().int().min(0),
});
export const ClearCreditHoldRequestSchema = z.object({
    reason: z
        .string()
        .min(10, 'Reason must be at least 10 characters — document why')
        .max(500),
});
export const ClearCreditHoldResponseSchema = z.object({
    facilityId: z.string().uuid(),
    previousStatus: z.enum(['NONE', 'WARNED', 'ACTIVE']),
    newStatus: z.enum(['NONE', 'WARNED', 'ACTIVE']),
});
//# sourceMappingURL=dunning-admin.schema.js.map